import Link from 'next/link';
import classes from './Listings.module.css';

const MessageCard = (props) => {
	const { item } = props;
	return (
		<>
			<div className={`${classes.MessageCard} border-0`}>
				<h2 className={classes.messageCardText}>{item.text}</h2>
				{item.info === 'seller' && (
					<Link href={`${item.link}`} className={classes.Link1}>
						{item.buttonText}
					</Link>
				)}
			</div>
		</>
	);
};

export default MessageCard;
